// stores/index.js
import { createPinia } from 'pinia'

// 导出 pinia 实例（用于 main.js）
export const pinia = createPinia()

// 集中导出所有 store，方便组件统一导入
export { useCouponStore } from './modules/coupon'
export { useActivityStore } from './modules/activity'
export { useDepartmentStore } from './modules/department'
